import React, { Component } from "react";
import ScrollAnimation from 'react-animate-on-scroll';


export default class ArticleModText extends Component {
	
    render () {
	
	    let block = this.props.block;
		
		let colClass = 'l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12';
		if (block.block_alignment == 'center') {
			colClass = colClass + ' l-grid__col--m-push-2-12 l-grid__col--l-push-3-12';
		} else if (block.block_alignment == 'right') {
			colClass = colClass + ' l-grid__col--m-push-4-12 l-grid__col--l-push-6-12';
		}
		
	    return (
	        <div className="l-block l-block--article-text">
	        	
	        	<div className="l-grid">
	
					<div className={colClass}>
						
						<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
						
							<div className={'scope-text scope-text--article scope-text--' + block.text_alignment + ' scope-text--' + block.text_size} dangerouslySetInnerHTML={{__html: block.text}}></div>
						
						</ScrollAnimation>
						
					</div>
					
				</div>
				
			</div>
		)
	}
}